import { createAxiosClient, type AxiosClientOptions } from '@invivodf/axios-client'
import { useAuthService } from '@b2ag/auth'
import { i18n } from '@b2ag/locale'
import { buildCallerId } from '@b2ag/utils/src/caller-id'

export {
  type AxiosInstance,
  type AxiosError,
  type AxiosResponse,
  type AxiosClientOptions,
} from '@invivodf/axios-client'

export function accessTokenSource(): Promise<string | null> {
  return useAuthService()
    .getAccessToken()
    .catch(() => null)
}

export function createFrontAxiosClient(baseUrl: string, options: AxiosClientOptions = {}) {
  return createAxiosClient(baseUrl, {
    timeout: 20000,
    callerId: buildCallerId(),
    localeSource: () => i18n.locale,
    accessTokenSource,
    ...options,
  })
}

export function createFrontAxiosClientAnonymous(baseUrl: string, options: AxiosClientOptions = {}) {
  return createAxiosClient(baseUrl, {
    timeout: 20000,
    callerId: buildCallerId(),
    localeSource: () => i18n.locale,
    ...options,
  })
}
